import React from 'react';
import {
	ItemContainer,
	SwitchWrapper,
	TextContent,
	Title,
	Description,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/styles.ts';
import { AdvancedSwitch } from '@dealstack/frontend/shared/components/Switch/AdvancedSwitch.tsx';

interface Props {
	title: string;
	description: string;
	checked: boolean;
	disabled?: boolean;
	onToggle?: () => void;
	showBorder?: boolean;
	dataTestId?: string;
}

export const ToggleRequirementItem: React.FC<Props> = ({
	title,
	description,
	checked,
	disabled = false,
	onToggle,
	showBorder = true,
	dataTestId,
}) => {
	return (
		<ItemContainer $showBorder={showBorder} data-testid={dataTestId}>
			<TextContent>
				<Title>{title}</Title>
				<Description>{description}</Description>
			</TextContent>

			<SwitchWrapper>
				<AdvancedSwitch selectedValue={checked} onChange={onToggle} disabled={disabled} />
			</SwitchWrapper>
		</ItemContainer>
	);
};
